import { getDefaultConfiguration } from '@nv/contexts'

const getConfigurations = ({ t }) => {
  const defaultConfiguration = getDefaultConfiguration(t)
  return {
    ...defaultConfiguration,
    languages: {
      en: 'English',
      fr: 'Francais',
    },
    votingMethodOptions: [
      { label: t('admin.electorsList.votedChannelOptions.online'), value: 'online' },

      // { label: t('admin.electorsList.votedChannelOptions.inPerson'), value: 'inPerson' },
    ],
    electionDate: new Date(),
    // registrationOpensDate: '2025-09-08T12:00:00', //TODO uncomment after testing
    minAge: 18,
    registrationPhoneRequired: true,
    includeSingleNameField: false,
    maxSessionTimeMinsAdmin: 6 * 60,
    maxSessionTimeMinsVoter: 30,
    votingDistrictOptions: [
      { value: 'CSLF-1', label: 'CSLF Zone 1' },
      { value: 'CSLF-2', label: 'CSLF Zone 2' },
      { value: 'CSLF-3', label: 'CSLF Zone 3' },
      { value: 'CSLF-4', label: 'CSLF Zone 4' },
      { value: 'CSLF-5', label: 'CSLF Zone 5' },
      { value: 'CSLF-6', label: 'CSLF Zone 6' },
      { value: 'PSB-1', label: 'PSB Zone 1' },
      { value: 'PSB-2', label: 'PSB Zone 2' },
      { value: 'PSB-3', label: 'PSB Zone 3' },
      { value: 'PSB-4', label: 'PSB Zone 4' },
      { value: 'PSB-5', label: 'PSB Zone 5' },
      { value: 'PSB-6', label: 'PSB Zone 6' },
      { value: 'PSB-7', label: 'PSB Zone 7' },
      { value: 'CSLF-NotFound', label: t('filters.CSLFZoneNotFound') },
      { value: 'PSB-NotFound', label: t('filters.PSBZoneNotFound') },
    ],
    knownIdNumberTextFieldConfig: { type: 'number', maxChars: 6 },
    enableManualEntryAddress: false,
    enableSingleFieldMailingAddress: false,
    enableDifferentMailingAddress: false,
    mailingAddressRequiredVoteByMail: true,
    displayStrikeOffOnlyVotingChannels: ['inPerson', 'online'], //TODO add voting channels
    reverseStrikeOffEnabled: false,
    includeWebAuthnLoginAdmin: false,
    includeLoginButtonRegistrationPage: true,
    confirmEligibilityToVote: false,
    voterAuth: {
      pinLogin: true,
    },
    voteReceiptType: 'external-link',
  }
}
export default getConfigurations
